import React from "react";
import { SingleRowsSection } from "./SingleRowSection";
import { SectionActionArea } from "./SectionActionArea";
export const SimpleSection = ({ data, rows, actions, styleConfig }) => {
  /**
 * expected data:
 * @param {any} data - used to pass back in callback of actions, can also be used to show custom styles based on data
 * @param {array} rows - [{id : "", label : "", value : ""}]  rows of data
 * @param {array} actions - [{id : "", callback : methodToCall, name : "name" }]  row of actions
 * @param {object} styleConfig -{ //Row container,label and value style class
 *                              sectionStyleConfig : {}, 
 *                              rowStyleConfig : {rowClass: "", rowLabelClass: "", rowValueClass: "" }
 *                              } 
 
 */
  let sectionStyleConfig = {
    sectionClass: "t_sc_c",
    sectionRowArea: "t_sc_ra",
    sectionActionArea: "t_sc_aa",
  };
  if (styleConfig && styleConfig.sectionStyleConfig) sectionStyleConfig = { ...sectionStyleConfig, ...styleConfig.sectionStyleConfig };
  return (
    <div className={sectionStyleConfig.sectionClass}>
      <div className={sectionStyleConfig.sectionRowArea}>
        <SingleRowsSection rows={rows} styleConfig={styleConfig && styleConfig.rowStyleConfig} />
      </div>
      {actions && (
        <div className={sectionStyleConfig.sectionActionArea}>
          <SectionActionArea actions={actions} data={data} />
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/CommonUI/Sections/SimpleSection.js